<template>
  <div class="MobileRightCont">
    <!--消息接收-->
    <div v-for="(item, index) in messageList_copy" :key="index">
      <!--实时回话-->
      <div
        v-if="item.roleType === 0"
        class="customerServiceDiv"
        style="display: flex; position: relative"
      >
        <div class="answers" style="overflow: auto hidden">
          <div
            :class="['text', 'markdown-body', { 'thinking-text': item.isThinking }]"
            @click="handleOpenImg"
            v-html="md.render(item.sendMessage)"
          />
          <div style="margin-top: 10px">
            <div
              v-if="item.pdfPath"
              style="display: flex; align-items: center; margin-bottom: 10px"
            >
              <span style="color: #ff6a00">{{ $t("chat.viewMoreAnswer") }}</span>
              <img
                v-for="(value, index) in item.pdfPath"
                class="more-image"
                :src="value"
                @click="handleOpenImg"
              />
            </div>
            <div style="display: flex; flex-direction: column; align-items: baseline">
              <div v-if="item.isPdf">
                <span style="color: rgb(21 132 165)">{{ $t("chat.sourceFrom") }}</span>
                <div>
                  <a
                    v-for="(value, index) in item.citePath"
                    style="display: block; color: rgb(21 132 165)"
                    target="_blank"
                    :href="value.citePath"
                  ><div class="overflow-hidden">{{ index + 1 }}、{{ value.title }}</div></a
                  >
                </div>
              </div>
              <div v-else-if="item.isCite">
                <span style="color: rgb(21 132 165)">{{ $t("chat.sourceFrom") }}</span>
                <div>
                  <a
                    v-for="(value, index) in item.citePath"
                    style="color: rgb(21 132 165)"
                    target="_blank"
                    :href="value.citePath"
                  ><div class="overflow-hidden">{{ index + 1 }}、{{ value.title }}</div></a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="view && index !== 0" class="advice">
          <span
            :class="item.isCopy ? 'el-icon-check' : 'el-icon-copy-document'"
            @click="handleShare(item)"
          ></span>
          <span
            v-show="isShowRefresh(index)"
            v-loading="refreshLoading"
            class="el-icon-refresh"
            @click="refreshReply(messageList_copy[index - 1])"
          ></span>
          <span
            :style="item.like === 0 ? 'color: #FF6A00;' : 'color: unset;'"
            class="iconfont icon-like"
            @click="handleAgree(0, item)"
          ></span>
          <span
            :style="item.like === 1 ? 'color: #FF6A00;' : 'color: unset;'"
            @click="handleAgree(1, item)"
          >
            <i
              style="transform: rotate(180deg); display: inline-block"
              class="iconfont icon-like"
            ></i>
          </span>
          <img
            v-show="item.channelId === 3"
            src="@/assets/images/exportExcel.svg"
            class="export-excel"
            @click="handleHtmlToExport(item.sendMessage)"
          />
          <el-button
            v-if="item.isShowStop"
            style="margin-left: 10px; height: 25px; width: 70px; padding: 3px 8px"
            size="mini"
            @click="handleAbort()"
          >{{ $t("chat.stopOutput") }}</el-button
          >
        </div>
      </div>

      <!--pdf单张图片展示-->
      <div v-if="item.roleType === 'upload'" class="customerServiceDiv" style="display: flex">
        <div class="answers">
          <div style="white-space: pre-wrap" class="text">
            <span>{{ $t("chat.excelPrefix") }}</span>
            <el-upload
              ref="upload"
              style="display: inline-block"
              accept=".xlsx,.xls"
              action="#"
              :multiple="false"
              :show-file-list="false"
              :on-change="handleFileChange"
              :before-upload="importFileBefore"
            >
              <el-button type="text">{{ $t("common.upload") }}</el-button>
            </el-upload>
            <span>{{ $t("chat.excelSuffix") }}</span>
          </div>
        </div>
      </div>

      <!--元件知识集-->
      <div
        v-if="item.roleType === 'element-tabs'"
        class="customerServiceDiv pdf-abstract-info"
        style="display: flex; max-width: 700px"
      >
        <div class="answers">
          <div style="white-space: pre-wrap" class="text">
            <div style="height: 570px">
              <el-tabs v-model="activeName">
                <el-tab-pane name="first" :label="$t('chat.tab.selection')">
                  <div style="max-height: 550px; overflow: auto">
                    <img class="item" src="@/assets/images/test/1.png" />
                  </div>
                </el-tab-pane>
                <el-tab-pane name="second" :label="$t('chat.tab.usage')">
                  <div style="max-height: 550px; overflow: auto">
                    <img class="item" src="@/assets/images/test/2.png" />
                  </div>
                </el-tab-pane>
                <el-tab-pane name="three" :label="$t('chat.tab.transport')">
                  <div style="max-height: 550px; overflow: auto">
                    <img class="item" src="@/assets/images/test/3.png" />
                  </div>
                </el-tab-pane>
                <el-tab-pane name="fore" :label="$t('chat.tab.tech')">
                  <div style="height: 550px; overflow: auto">
                    <img class="item" src="@/assets/images/test/4.png" />
                  </div>
                </el-tab-pane>
                <el-tab-pane name="five" :label="$t('chat.tab.dimension')">
                  <div
                    style="display: flex; flex-direction: column; max-height: 550px; overflow: auto"
                  >
                    <img class="item" src="@/assets/images/test/5.png" />
                    <img class="item" src="@/assets/images/test/6.png" />
                    <img class="item" src="@/assets/images/test/7.png" />
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </div>

      <!--表格展示-->
      <div
        v-if="item.roleType === 'table'"
        ref="tableShowRef"
        class="customerServiceDiv pdf-abstract-info"
        style="display: flex; max-width: 700px"
        @mouseup="handleMouseUp"
        @contextmenu.prevent="handleContextMenu"
      >
        <div class="answers">
          <div
            style="white-space: pre-wrap"
            class="text"
            @click="handleOpenImg"
            v-html="item.sendMessage"
          />
        </div>
      </div>

      <!-- 热门和更多问题 -->
      <div v-if="item.roleType === 'more'" class="customerServiceDiv" style="display: flex">
        <div class="answers">
          <div>
            <div>{{ item.title }}</div>
            <div style="margin-top: 10px">
              <div
                v-for="question in item.questions"
                class="more-hot-question"
                @click="clickMoreQuestion(question)"
              >
                <div class="overflow-hidden">{{ question }}</div>
                <div class="el-icon-arrow-right" style="font-size: 14px; font-weight: 700" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--自己-->
      <div v-if="item.roleType === 2" class="myselfDiv">
        <div class="news">
          <div v-if="getImageUrls(item).length > 0" class="user-image-list">
            <img
              v-for="url in getImageUrls(item)"
              :key="url"
              :src="url"
              referrerpolicy="no-referrer"
              @click="handleOpenImg"
            />
          </div>
          <div v-if="getNonImageFiles(item.file_list).length > 0" class="user-file-list">
            <div v-for="(file, fIdx) in getNonImageFiles(item.file_list)" :key="fIdx" class="file-item">
              <a :href="file.url" target="_blank" class="file-link">
                <i class="el-icon-document"></i>
                <span>{{ file.file_name }}</span>
              </a>
            </div>
          </div>
          <div
            class="text"
            style="white-space: pre-wrap"
            @click="handleOpenImg"
            v-html="item.sendMessage"
          ></div>
        </div>
      </div>

      <!--历史ai回答-->
      <div v-if="item.children && item.children.length > 0" class="customerServiceDiv">
        <!--        <div class="noticeDiv">-->
        <!--          <div class="moreSession">{{ item.children[0].sendTime | formatDate()}}</div>-->
        <!--        </div>-->
        <div style="display: flex; position: relative">
          <div class="answers" style="overflow: auto hidden">
            <div
              class="text markdown-body"
              @click="handleOpenImg"
              v-html="md.render(item.children[0].sendMessage)"
            />
            <div style="margin-top: 10px">
              <div
                v-if="item.children[0].pdfPath"
                style="display: flex; align-items: center; margin-bottom: 10px"
              >
                <span style="color: #ff6a00">{{ $t("chat.viewMoreAnswer") }}</span>
                <img
                  v-for="(value, index) in item.children[0].pdfPath"
                  class="more-image"
                  :src="value"
                  @click="handleOpenImg"
                />
              </div>
              <div style="display: flex; flex-direction: column; align-items: baseline">
                <div v-if="item.children[0].isPdf">
                  <span style="color: rgb(21 132 165)">{{ $t("chat.sourceFrom") }}</span>
                  <div>
                    <a
                      v-for="(value, index) in item.children[0].citePath"
                      style="color: rgb(21 132 165)"
                      target="_blank"
                      :href="value.citePath"
                    ><div class="overflow-hidden">{{ index + 1 }}、{{ value.title }}</div></a
                    >
                  </div>
                </div>
                <div v-else-if="item.children[0].isCite">
                  <span style="color: rgb(21 132 165)">{{ $t("chat.sourceFrom") }}</span>
                  <div>
                    <a
                      v-for="(value, index) in item.children[0].citePath"
                      style="color: rgb(21 132 165)"
                      target="_blank"
                      :href="value.citePath"
                    ><div class="overflow-hidden">{{ index + 1 }}、{{ value.title }}</div></a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="view" class="advice">
            <span
              :class="item.children[0].isCopy ? 'el-icon-check' : 'el-icon-copy-document'"
              @click="handleShare(item.children[0])"
            ></span>
            <span
              v-show="index === messageList_copy.length - 1"
              v-loading="refreshLoading"
              class="el-icon-refresh"
              @click="refreshReply(item)"
            ></span>
            <img
              v-show="item.children[0].channelId === 3"
              src="@/assets/images/exportExcel.svg"
              class="export-excel"
              @click="handleHtmlToExport(item.children[0].sendMessage)"
            />
          </div>
        </div>
      </div>

      <!--普通状态通知显示-->
      <div v-if="item.roleType === 'notice'" class="noticeDiv">
        <div class="moreSession">
          {{ item.sendMessage }}
        </div>
      </div>

      <div style="clear: both"></div>

      <!--柜体显示-->
      <div v-if="item.roleType === 'form'" class="customerServiceDiv" style="display: flex">
        <div class="answers">
          <div class="bom-form">
            <el-form ref="deviceForm" :model="deviceInfo" :rules="ruleValidate">
              <el-form-item prop="name" :label="$t('chat.device.purpose')">
                <el-select
                  v-model="deviceInfo.name"
                  style="width: 100%"
                  :placeholder="$t('chat.device.purpose')"
                  @change="handleChange('name')"
                >
                  <el-option
                    v-for="item in solrList.nameList"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
              <el-form-item prop="model" :label="$t('chat.device.model')">
                <el-select
                  v-model="deviceInfo.model"
                  style="width: 100%"
                  :placeholder="$t('chat.device.model')"
                  @change="handleChange('model')"
                >
                  <el-option
                    v-for="item in solrList.modelList"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
              <el-form-item prop="size" :label="$t('chat.device.size')">
                <el-select
                  v-model="deviceInfo.size"
                  style="width: 100%"
                  :placeholder="$t('chat.device.size')"
                  @change="handleChange('size')"
                >
                  <el-option
                    v-for="item in solrList.sizeList"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="typesof" :label="$t('chat.device.switchType')">
                <el-select
                  v-model="deviceInfo.typesof"
                  style="width: 100%"
                  :placeholder="$t('chat.device.switchType')"
                  @change="handleChange('typesof')"
                >
                  <el-option
                    v-for="item in solrList.typesofList"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
              <el-form-item prop="install" :label="$t('chat.device.installType')">
                <el-select
                  v-model="deviceInfo.install"
                  style="width: 100%"
                  :placeholder="$t('chat.device.installType')"
                  @change="handleChange('install')"
                >
                  <el-option
                    v-for="item in solrList.installList"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
              <el-form-item prop="electric" :label="$t('chat.device.current')">
                <el-select
                  v-model="deviceInfo.electric"
                  style="width: 100%"
                  :placeholder="$t('chat.device.current')"
                  @change="handleChange('electric')"
                >
                  <el-option
                    v-for="item in solrList.electricList"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
              <el-form-item prop="size" :label="$t('chat.device.breaking')">
                <el-select
                  v-model="deviceInfo.segmenting"
                  style="width: 100%"
                  :placeholder="$t('chat.device.breaking')"
                  @change="handleChange('segmenting')"
                >
                  <el-option
                    v-for="item in solrList.segmentingList"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
              <el-form-item prop="size" :label="$t('chat.device.brand')">
                <el-select
                  v-model="deviceInfo.brand"
                  style="width: 100%"
                  :placeholder="$t('chat.device.brand')"
                  @change="handleChange('brand')"
                >
                  <el-option
                    v-for="item in solrList.brandList"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
            </el-form>
            <div style="text-align: center">
              <el-button
                type="primary"
                :disabled="deviceLoading"
                :loading="deviceLoading"
                @click="handleClickDevice()"
              >{{ $t("common.submit") }}</el-button
              >
            </div>
          </div>
        </div>
      </div>

      <!--用户选择展示柜体表单-->
      <div v-if="item.roleType === 'bomForm'" class="customerServiceDiv" style="display: flex">
        <div class="answers">
          <div>
            {{ item.title }}：<el-button type="text" @click="initBomList">{{
              $t("chat.generateForm")
            }}</el-button>
          </div>
        </div>
      </div>
      <!--开通会员-->
      <div v-if="item.roleType === 'vipForm'" class="customerServiceDiv" style="display: flex">
        <div class="answers">
          <div>
            {{ item.title }}：<el-button type="text" @click="handleOpenVip">{{
              $t("chat.openVip")
            }}</el-button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showInit" style="width: 100%; height: 100%">
      <div class="chat-init">
        <img class="item logo" style="height: 50px" src="@/assets/images/login/init-logo.png" />
        <div class="item text" style="font-size: 14px; color: #333333; line-height: 22px">
          <span style="white-space: pre-wrap">{{ $t("chat.welcome") }}</span>
        </div>
        <div class="init-question">
          <div class="question">
            <el-card
              v-for="(item, index) in channelList"
              v-if="index < 4"
              shadow="hover"
              :body-style="{ padding: '0px', cursor: 'pointer' }"
            >
              <div
                class="question-div"
                :class="index > 2 ? 'div-disabled' : ''"
                @click="clickQueryChannel(index, item)"
              >
                <div style="font-size: 15px; font-weight: 600">{{ item.channelName }}</div>
                <div class="question-content">
                  <div
                    class="overflow-hidden-2"
                    style="font-size: 13px; font-weight: 400; color: #676c90; height: 40px"
                  >
                    {{ item.description }}
                  </div>
                  <div v-if="item.showImage"><img :src="item.showImage" /></div>
                </div>
              </div>
            </el-card>
          </div>
        </div>
      </div>
    </div>
    <!--鼠标右键点击出现页面-->
    <div v-show="menuVisible">
      <el-menu
        id="rightClickMenu"
        class="el-menu-vertical"
        text-color="#fff"
        @select="handleRightSelect"
      >
        <el-menu-item index="1" class="menuItem">
          <span slot="title" style="color: #999; position: absolute; left: 10px">{{
              $t("chat.componentKnowledge")
            }}</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div v-if="initLoading" class="initLoadingDiv">
      <div class="animation_div"></div>
      <div style="color: #555; padding-top: 5px">{{ $t("chat.initLoading") }}</div>
    </div>
    <view-picture ref="viewPicture" v-model="viewPictureVisible" @callback="viewPictureCallback" />
  </div>
</template>

<script>
import XLSX from "xlsx";
import SessionApi from "@/api/session";
import DeviceApi from "@/api/device";
import ChatApi from "@/api/chat";
import { sendMessage, getMoreQuestions, saveQueryStatus, getHotQuestion } from "@/api/chatbot";
import ViewPicture from "../VierPicture/index";
import { getChannelAll, getChannelById } from "@/constants/channel";
import NoSleep from "nosleep.js";
import { md } from "@/utils/markdown";

export default {
  name: "MobileHomeAiChat",
  components: { ViewPicture },
  props: {
    sessionId: String,
    channelId: Number,
    messageList: [],
    initLoading: Boolean,
    sendLoading: Boolean,
    view: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  data() {
    return {
      md: md,
      noSleep: null,
      deviceLoading: false,
      ruleValidate: {},
      solrList: {
        nameList: [],
        modelList: [],
        sizeList: [],
        typesofList: [],
        installList: [],
        electricList: [],
        segmentingList: [],
        brandList: [],
      },
      deviceInfo: {
        name: "出线柜",
        model: "",
        size: "",
        typesof: "",
        install: "",
        electric: "",
        segmenting: "",
        brand: "",
      },
      channelList: [],
      activeName: "first",
      menuVisible: false,
      showInit: false,
      fileInfo: {},
      viewPictureVisible: false,
      refreshLoading: false,
      isCopy: false,
      messageList_copy: [],
      speed: 110,
      aiHistory: [],
    };
  },
  computed: {
    userId() {
      return this.$store.state.user.userId;
    },
    loginUserName() {
      return this.$store.state.user.truename;
    },
    headImagePath() {
      return this.$store.state.user.headImagePath;
    },
    isLogin() {
      return this.$store.state.user.userId != null;
    },
  },
  watch: {
    messageList: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        this.messageList_copy = newValue;
      },
    },
  },
  mounted() {
    this.noSleep = new NoSleep();
  },
  beforeDestroy() {
    this.noSleep = null;
  },
  methods: {
    handleOpenVip() {
      window.location.href = process.env.VUE_APP_D123_URL + "/?op=dxxOpenVip";
    },
    getImageUrls(item) {
      if (!item) {
        return [];
      }
      if (Array.isArray(item.imageUrls)) {
        return item.imageUrls;
      }
      if (Array.isArray(item.image_urls)) {
        return item.image_urls;
      }
      if (typeof item.imageUrls === "string" && item.imageUrls) {
        return item.imageUrls.split(",").filter(Boolean);
      }
      if (typeof item.image_urls === "string" && item.image_urls) {
        return item.image_urls.split(",").filter(Boolean);
      }
      return [];
    },
    getNonImageFiles(fileList) {
      if (!fileList || !Array.isArray(fileList)) {
        return [];
      }
      return fileList.filter(file => file.kind !== 'image');
    },
    handleAbort() {
      this.$emit("rollbackLoading", false);
      if (this.ctrl) {
        this.ctrl.abort(); // 中断请求
      }
    },
    toggleNoSleep(isNoSleep) {
      if (this.noSleep) {
        if (isNoSleep) {
          this.noSleep.enable();
        } else {
          this.noSleep.disable();
        }
      }
    },
    async handleClickDevice() {
      this.deviceLoading = true;
      const obj = {};
      if (this.deviceInfo.name) {
        obj.c_name_marking = this.deviceInfo.name;
      }
      if (this.deviceInfo.model) {
        obj.c_model_marking = this.deviceInfo.model;
      }
      if (this.deviceInfo.size) {
        const size = this.deviceInfo.size.split("*");
        obj.c_width = size[0];
        obj.c_height = size[1];
        obj.c_depth = size[2];
      }
      if (this.deviceInfo.typesof) {
        obj.c_typesof_marking = this.deviceInfo.typesof;
      }
      if (this.deviceInfo.install) {
        obj.c_install_marking = this.deviceInfo.install;
      }
      if (this.deviceInfo.electric) {
        obj.c_electric = this.deviceInfo.electric;
      }
      if (this.deviceInfo.segmenting) {
        obj.c_segmenting = this.deviceInfo.segmenting;
      }
      if (this.deviceInfo.brand) {
        obj.c_brand = this.deviceInfo.brand;
      }
      const message = this.$t("chat.device.summary", {
        name: this.deviceInfo.name,
        model: this.deviceInfo.model,
        size: this.deviceInfo.size,
        typesof: this.deviceInfo.typesof,
        install: this.deviceInfo.install,
        electric: this.deviceInfo.electric,
        segmenting: this.deviceInfo.segmenting,
        brand: this.deviceInfo.brand,
      });
      const chatInfo = Object.assign({
        device_param: obj,
        sendMessage: message,
        sessionId: this.sessionId,
        channelId: this.channelId,
        roleType: 0,
      });
      this.messageList_copy.pop();
      this.messageList_copy.push(chatInfo);
      await this.aiReply(chatInfo);
      this.deviceLoading = false;
    },
    handleChange(val) {
      const obj = [];
      const deviceInfo = {
        name: "",
        model: "",
        size: "",
        typesof: "",
        install: "",
        electric: "",
        segmenting: "",
        brand: "",
      };
      if (val === "name") {
        deviceInfo.name = this.deviceInfo.name;
      }
      if (val === "model") {
        deviceInfo.name = this.deviceInfo.name;
        deviceInfo.model = this.deviceInfo.model;
      }
      if (val === "size") {
        deviceInfo.name = this.deviceInfo.name;
        deviceInfo.model = this.deviceInfo.model;
        deviceInfo.size = this.deviceInfo.size;
      }
      if (val === "typesof") {
        deviceInfo.name = this.deviceInfo.name;
        deviceInfo.model = this.deviceInfo.model;
        deviceInfo.size = this.deviceInfo.size;
        deviceInfo.typesof = this.deviceInfo.typesof;
      }
      if (val === "install") {
        deviceInfo.name = this.deviceInfo.name;
        deviceInfo.model = this.deviceInfo.model;
        deviceInfo.size = this.deviceInfo.size;
        deviceInfo.typesof = this.deviceInfo.typesof;
        deviceInfo.install = this.deviceInfo.install;
      }
      if (val === "electric") {
        deviceInfo.name = this.deviceInfo.name;
        deviceInfo.model = this.deviceInfo.model;
        deviceInfo.size = this.deviceInfo.size;
        deviceInfo.typesof = this.deviceInfo.typesof;
        deviceInfo.install = this.deviceInfo.install;
        deviceInfo.electric = this.deviceInfo.electric;
      }
      if (val === "segmenting") {
        deviceInfo.name = this.deviceInfo.name;
        deviceInfo.model = this.deviceInfo.model;
        deviceInfo.size = this.deviceInfo.size;
        deviceInfo.typesof = this.deviceInfo.typesof;
        deviceInfo.install = this.deviceInfo.install;
        deviceInfo.electric = this.deviceInfo.electric;
        deviceInfo.segmenting = this.deviceInfo.segmenting;
      }
      if (val === "brand") {
        deviceInfo.name = this.deviceInfo.name;
        deviceInfo.model = this.deviceInfo.model;
        deviceInfo.size = this.deviceInfo.size;
        deviceInfo.typesof = this.deviceInfo.typesof;
        deviceInfo.install = this.deviceInfo.install;
        deviceInfo.electric = this.deviceInfo.electric;
        deviceInfo.segmenting = this.deviceInfo.segmenting;
        deviceInfo.brand = this.deviceInfo.brand;
      }
      if (deviceInfo.name) {
        obj.push(Object.assign({ field: "c_name_marking", value: deviceInfo.name }));
      }
      if (deviceInfo.model) {
        obj.push(Object.assign({ field: "c_model_marking", value: deviceInfo.model }));
      }
      if (deviceInfo.size) {
        obj.push(Object.assign({ field: "c_size_marking", value: deviceInfo.size }));
      }
      if (deviceInfo.typesof) {
        obj.push(Object.assign({ field: "c_typesof_marking", value: deviceInfo.typesof }));
      }
      if (deviceInfo.install) {
        obj.push(Object.assign({ field: "c_install_marking", value: deviceInfo.install }));
      }
      if (deviceInfo.electric) {
        obj.push(Object.assign({ field: "c_electric", value: deviceInfo.electric }));
      }
      if (deviceInfo.segmenting) {
        obj.push(Object.assign({ field: "c_segmenting", value: deviceInfo.segmenting }));
      }
      if (deviceInfo.brand) {
        obj.push(Object.assign({ field: "c_brand", value: deviceInfo.brand }));
      }
      this.deviceInfo = deviceInfo;
      console.log(this.deviceInfo);
      this.selectDevice(obj);
    },
    async selectDevice(obj) {
      const res = await this.axios.post(DeviceApi.selectMetaDevice, obj);
      this.solrList = res;
      const name = res.nameList.find((item) => item === this.deviceInfo.name);
      if (!name && res.nameList.length > 0) {
        this.deviceInfo.name = res.nameList[0];
      } else {
        this.deviceInfo.name = name === undefined ? "" : name;
      }
      const model = res.modelList.find((item) => item === this.deviceInfo.model);
      if (!model && res.modelList.length > 0) {
        this.deviceInfo.model = res.modelList[0];
      } else {
        this.deviceInfo.model = model === undefined ? "" : model;
      }
      const size = res.sizeList.find((item) => item === this.deviceInfo.size);
      if (!size && res.sizeList.length > 0) {
        this.deviceInfo.size = res.sizeList[0];
      } else {
        this.deviceInfo.size = size === undefined ? "" : size;
      }
      const typesof = res.typesofList.find((item) => item === this.deviceInfo.typesof);
      if (!typesof && res.typesofList.length > 0) {
        this.deviceInfo.typesof = res.typesofList[0];
      } else {
        this.deviceInfo.typesof = typesof === undefined ? "" : typesof;
      }
      const install = res.installList.find((item) => item === this.deviceInfo.install);
      if (!install && res.installList.length > 0) {
        this.deviceInfo.install = res.installList[0];
      } else {
        this.deviceInfo.install = install === undefined ? "" : install;
      }
      const electric = res.electricList.find((item) => item === this.deviceInfo.electric);
      if (!electric && res.electricList.length > 0) {
        this.deviceInfo.electric = res.electricList[0];
      } else {
        this.deviceInfo.electric = electric === undefined ? "" : electric;
      }
      const segmenting = res.segmentingList.find((item) => item === this.deviceInfo.segmenting);
      if (!segmenting && res.segmentingList.length > 0) {
        this.deviceInfo.segmenting = res.segmentingList[0];
      } else {
        this.deviceInfo.segmenting = segmenting === undefined ? "" : segmenting;
      }
      const brand = res.brandList.find((item) => item === this.deviceInfo.brand);
      if (!brand && res.brandList.length > 0) {
        this.deviceInfo.brand = res.brandList[0];
      } else {
        this.deviceInfo.brand = brand === undefined ? "" : brand;
      }
    },
    async checkImages(images) {
      const rightImages = [];
      if (images && images.length > 0) {
        for (let i = 0; i < images.length; i++) {
          try {
            const res = await fetch(images[i]);
            if (res.status === 200) {
              const imageBlob = await res.blob();
              if (imageBlob.size > 100) {
                rightImages.push(images[i]);
              }
            }
          } catch (e) {}
        }
      }
      return rightImages;
    },
    async clickQueryChannel(index, val) {
      if (index > 2) {
        return;
      }
      if (!this.isLogin) {
        window.location.href = process.env.VUE_APP_D123_URL + "/?op=dxxLogin";
        return;
      }
      this.$emit("rollbackLoading", true);
      this.handleEditInitShow();
      const obj = Object.assign({
        channelId: val.id,
        sessionId: this.sessionId,
        sendMessage: val.channelName,
        sendTime: this.$options.filters.formatDate(new Date()),
        roleType: 2,
      });
      this.messageList_copy.push(obj);
      // 保存数据到数据库
      const res = await this.axios.post(ChatApi.saveFirstChat, obj);
      this.$router.push({ name: "history", params: { sessionId: this.sessionId } }).catch(() => {});
      await this.$emit("sendChannelId", res.channelId);
      const homeMobileAiChatDiv = document.getElementById("userMobileMessage");
      if (res.channelId === 3) {
        homeMobileAiChatDiv.style.height = "100%";
        await this.initBomList();
        return;
      } else {
        homeMobileAiChatDiv.height = "calc(100% - 100px)";
        const channelRes = getChannelById(val.id);
        if (channelRes.message) {
          const message = JSON.parse(channelRes.message);
          const obj = Object.assign({
            channelId: val.id,
            sessionId: this.sessionId,
            title: this.$t("chat.title.tryAsk"),
            questions: message,
            sendTime: this.$options.filters.formatDate(new Date()),
            roleType: "more",
          });
          this.messageList_copy.push(obj);
          this.toBottom(200);
        }
      }
      this.$emit("rollbackLoading", false);
    },
    async initBomList() {
      // 柜体
      this.deviceInfo = Object.assign({
        name: "",
        model: "",
        size: "",
        typesof: "",
        install: "",
        electric: "",
        segmenting: "",
        brand: "",
      });
      await this.selectDevice([]);
      const obj = Object.assign({
        channelId: this.channelId,
        sessionId: this.sessionId,
        sendTime: this.$options.filters.formatDate(new Date()),
        roleType: "form",
      });
      this.messageList_copy.push(obj);
      this.toBottom(200);
    },
    handleMouseUp() {
      const selection = window.getSelection();
      this.selectedText = selection.toString();
    },
    handleContextMenu(event) {
      if (this.selectedText) {
        document.addEventListener("click", (e) => {
          this.menuVisible = false;
        });
        this.$nextTick(function () {
          this.menuVisible = true;
          const menu = document.querySelector("#rightClickMenu");
          /* 菜单定位基于鼠标点击位置 */
          menu.style.left = event.clientX + "px";
          if (
            this.$refs.tableShowRef.offsetHeight <
            event.clientY + this.$refs.tableShowRef.scrollTop + menu.offsetHeight
          ) {
            menu.style.top = event.clientY - menu.offsetHeight + 10 + "px";
          } else {
            menu.style.top = event.clientY + 10 + "px";
          }
          menu.style.position = "absolute"; // 为新创建的DIV指定绝对定位
          menu.style.width = 120 + "px";
        });
      }
    },
    handleRightSelect(key) {
      // 右键菜单选择事件
      if (key == 1) {
        // 元件知识集
        this.menuVisible = false;
        const obj = Object.assign({
          channelId: this.channelId,
          sessionId: this.sessionId,
          sendTime: this.$options.filters.formatDate(new Date()),
          roleType: "element-tabs",
        });
        this.messageList_copy.push(obj);
        this.toBottom(550);
      }
    },
    handleFileChange(file) {
      if (!file.name.endsWith(".xlsx") && !file.name.endsWith(".xls")) {
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });

        // 假设解析第一个工作表
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];

        // 将工作表转换为HTML
        const html = XLSX.utils.sheet_to_html(worksheet);
        const obj = Object.assign({
          channelId: this.channelId,
          sessionId: this.sessionId,
          sendMessage: html,
          sendTime: this.$options.filters.formatDate(new Date()),
          roleType: "table",
        });
        this.messageList_copy.push(obj);
        this.toBottom(200);
      };
      reader.readAsBinaryString(file.raw);
    },
    importFileBefore(file) {
      // 在这里可以做一些文件类型的校验
      if (!file.name.endsWith(".xlsx") && !file.name.endsWith(".xls")) {
        this.$message.error("请上传Excel文件");
      }
      return false;
    },
    async handleEditInitShow(value) {
      this.showInit = value;
      if (value) {
        this.getTopQuestion();
      }
    },
    async getTopQuestion() {
      this.channelList = getChannelAll();
    },
    handleAgree(like, val) {
      let messageStatus;
      let adviceContent;
      if (like === val.like) {
        // 再次点击相同图标，取消评价
        messageStatus = 0;
        val.like = null;
        adviceContent = "";
      } else {
        // message_status: 1=不喜欢, 2=喜欢
        messageStatus = like === 0 ? 2 : 1;
        adviceContent = like === 0 ? "回答的很棒！" : "回答不是很清楚";
        val.like = like;
      }
      const params = Object.assign({
        answer_id: val.id,
        message_status: messageStatus,
        advice_content: adviceContent,
      });
      saveQueryStatus(params);
    },
    // 点击标题
    clickMoreQuestion(question) {
      if (this.sendLoading) {
        this.$message.warning("当前正在解答疑问，请稍后点击。");
        return;
      }
      if (!this.isLogin) {
        window.location.href = process.env.VUE_APP_D123_URL + "/?op=dxxLogin";
        return;
      }
      this.handleEditInitShow(false);
      // 存入自己的消息列表
      const obj = Object.assign({
        channelId: this.channelId,
        sessionId: this.sessionId,
        sendMessage: question,
        sendTime: this.$options.filters.formatDate(new Date()),
        roleType: 2,
      });
      this.messageList.push(obj);
      this.$emit("rollbackLoading", true);
      this.toBottom(200);
      this.refreshLoading = false;
      this.aiReply(obj);
    },
    // 是否展示重新生成
    isShowRefresh(index) {
      return (
        (index === this.messageList_copy.length - 1 &&
          this.messageList_copy[this.messageList_copy.length - 1].roleType !== "more") ||
        (index === this.messageList_copy.length - 2 &&
          this.messageList_copy[this.messageList_copy.length - 1].roleType === "more")
      );
    },
    // 重新生成
    refreshReply(val) {
      if (this.sendLoading) {
        this.$message.warning("当前正在解答疑问，请稍后点击。");
        return;
      }
      this.refreshLoading = true;
      // 存入自己的消息列表
      const obj = Object.assign({
        channelId: this.channelId,
        sessionId: this.sessionId,
        sendMessage: val.sendMessage,
        sendTime: this.$options.filters.formatDate(new Date()),
        roleType: 2,
      });
      this.messageList.push(obj);
      this.$emit("rollbackLoading", true);
      this.toBottom(200);
      this.refreshLoading = false;
      this.aiReply(obj);
    },
    // 复制
    handleShare(val) {
      console.log(val);
      // 创建临时文本输入框
      const input = document.createElement("input");
      input.setAttribute("value", val.sendMessage);
      document.body.appendChild(input);
      // 选择并复制文本
      input.select();
      document.execCommand("copy");
      // 移除临时文本输入框
      document.body.removeChild(input);
      val.isCopy = true;
      setTimeout(() => {
        val.isCopy = false;
      }, 1000);
      clearTimeout();
    },
    // 关闭图片
    viewPictureCallback() {
      this.viewPictureVisible = false;
    },
    // 导出
    async handleHtmlToExport(val) {
      this.$refs.viewPicture.handleHtmlToExport(val);
    },
    // 导出
    async handleExport(images) {
      const result = await this.checkImages(images);
      if (result.length < 1) {
        this.$message.error("暂无表格数据导出");
      }
      this.$refs.viewPicture.handleExport(result[0]);
    },
    // 打开图片
    handleOpenImg(event, isExport) {
      const target = event.target;
      if (target.tagName === "IMG") {
        const imgUrl = target.getAttribute("src");
        const imageWidth = target.naturalWidth;
        const imageHeight = target.naturalHeight;
        // 获取窗口大小
        const containerWidth = window.innerWidth * 0.8;
        const containerHeight = window.innerHeight * 0.8;
        // 计算图片的缩放比例，保持图片的宽高比
        const scaleWidth = containerWidth / imageWidth;
        const scaleHeight = containerHeight / imageHeight;
        const scale = Math.min(scaleWidth, scaleHeight);
        this.$refs.viewPicture.openView(scale, imgUrl, isExport);
        this.viewPictureVisible = true;
      }
    },
    // ai回复
    async aiReply(chatInfo) {
      this.toggleNoSleep(true);
      // 保存会话
      const { imageUrls, ...sessionInfo } = chatInfo;
      sessionInfo.file_list = (sessionInfo.file_list || []).map(({ url, ...rest }) => rest);
      await this.axios.post(SessionApi.saveSession, sessionInfo);
      this.$router.push({ name: "history", params: { sessionId: this.sessionId } }).catch(() => {});
      const sendId = Number.parseInt(this.userId, 10);
      // 发送消息
      const chatParams = Object.assign({
        device_param: chatInfo.device_param,
        session_id: this.sessionId,
        channel_id: this.channelId,
        send_message: chatInfo.sendMessage,
        send_id: this.userId,
        file_list: (chatInfo.file_list || []).map(({ url, ...rest }) => rest),
        source: 2,
      });
      const replyMessage = Object.assign({
        like: null,
        title: "",
        citePath: "",
        isPdf: 0,
        isCite: 0,
        channelId: this.channelId,
        sessionId: this.sessionId,
        sendMessage: this.$t("chat.status.thinking"),
        sendTime: new Date(),
        roleType: 0,
        isCopy: false,
        pdfPath: "",
        isShowStop: true,
        isThinking: true,
      });
      this.messageList_copy.push(replyMessage);
      this.toBottom(100);
      this.ctrl = new AbortController(); // 用于中断请求
      try {
        const response = await sendMessage(chatParams, this.ctrl);
        if (response && response.status === 200) {
          const contentType = response.headers.get("Content-Type");
          console.log("contentType -", contentType);
          if (contentType === "application/json") {
            // wiki的答案，直接返回
            const jsonData = await response.json();
            await this.getWikiAnswer(jsonData, chatInfo, replyMessage);
            this.toggleNoSleep(false);
            return;
          }
          const reader = response.body.pipeThrough(new TextDecoderStream()).getReader();
          let index = 1;
          let receiveMessage = "";
          let questionId = null;
          let isCite = null;
          let isPdf = null;
          let citePath = [];
          let pdfPath = "";
          let title = "";
          while (true) {
            var { value, done } = await reader.read();
            // value = {"finish_reason": "stop", "title": "在编辑母排时提示：所选对象为异常母排，请重新选择！", "answer": "升级了。", "api_path": "https://forum.dq123.com/d/3011-SP-00180"}
            if (done) {
              replyMessage.isShowStop = false;
              replyMessage.title = title;
              replyMessage.isCite = isCite;
              replyMessage.isPdf = isPdf;
              replyMessage.citePath = citePath;
              if (isPdf && pdfPath) {
                const pdfImages = pdfPath.split(",");
                const rightImages = await this.checkImages(pdfImages);
                if (rightImages.length > 0) {
                  replyMessage.pdfPath = rightImages;
                }
              }
              break; // 请求结束 {value: undefined, done: true}
            }
            // 处理 SSE 格式数据
            // 以换行符分割可能的多条消息
            const messages = value.split("\n\n");
            for (const msg of messages) {
              if (msg.startsWith("data: ")) {
                const jsonString = msg.slice(6); // 去掉 "data: "
                const jsonData = JSON.parse(jsonString);
                if (jsonData.status || jsonData.retcode !== 200) {
                  this.toggleNoSleep(false);
                  replyMessage.isThinking = false;
                  replyMessage.isShowStop = false;
                  replyMessage.sendMessage = "请求异常，请稍后重试！";
                  this.$emit("rollbackLoading", false);
                  this.$message.error("请求异常，请稍后重试！");
                  return;
                }
                questionId = jsonData.data.question_id;
                isCite = jsonData.data.is_cite;
                isPdf = jsonData.data.is_pdf;
                citePath = jsonData.data.cite_path;
                pdfPath = jsonData.data.pdf_path;
                title = jsonData.data.title;
                if (index === 1) {
                  Object.assign(replyMessage, {
                    like: null,
                    title: "",
                    citePath: "",
                    isPdf: 0,
                    isCite: 0,
                    channelId: this.channelId,
                    sessionId: this.sessionId,
                    sendMessage: receiveMessage,
                    sendTime: new Date(),
                    roleType: 0,
                    isCopy: false,
                    pdfPath: "",
                    isShowStop: true,
                    isThinking: false,
                  });
                }
                if (jsonData.data.answer_id) {
                  replyMessage.id = jsonData.data.answer_id;
                }
                const characters = jsonData.data.answer.split("");
                // 逐个字地添加到 output 变量中，并更新页面
                for (const char of characters) {
                  receiveMessage += char;
                  // 更新页面上的内容，实现打字机效果
                  replyMessage.sendMessage = receiveMessage;
                }
                this.toBottom(100);
                index++;
              }
            }
          }
          if (this.channelId == null || this.channelId == 2) {
            // 未选择意图/选择的是查图纸再查询更多回答
            await this.getChatMoreQuestions(chatInfo, questionId);
          }
          if (this.channelId != null && this.channelId == 3) {
            const obj = Object.assign({
              channelId: this.channelId,
              sessionId: this.sessionId,
              title: this.$t("chat.title.satisfied"),
              sendTime: this.$options.filters.formatDate(new Date()),
              roleType: "bomForm",
            });
            this.messageList.push(obj);
            this.toBottom(100);
          }
        }
        this.$emit("rollbackLoading", false);
      } catch (error) {
        if (error.name === "AbortError") {
          console.log("请求被中断");
          if (replyMessage.isThinking) {
            replyMessage.sendMessage = this.$t("chat.status.stopped");
          }
        } else {
          if (replyMessage.isThinking) {
            replyMessage.sendMessage = "当前网络异常，请稍后再试！";
          }
          this.$message({
            message: "当前网络异常，请稍后再试！",
            type: "warning",
            duration: 5 * 1000,
          });
        }
        replyMessage.isThinking = false;
        this.$emit("rollbackLoading", false);
      } finally {
        this.toggleNoSleep(false);
        replyMessage.isShowStop = false;
      }
    },
    // wiki的答案
    async getWikiAnswer(jsonData, chatInfo, replyMessage) {
      if (jsonData && jsonData.retcode === 200) {
        // 非流式数据（帮助与支持的数据）
        const wikiAnswer = Object.assign({
          id: jsonData.data.answer_id,
          like: null,
          title: jsonData.data.title,
          citePath: jsonData.data.cite_path,
          isCite: jsonData.data.is_cite,
          channelId: this.channelId,
          sessionId: this.sessionId,
          sendMessage: jsonData.data.content,
          sendTime: new Date(),
          roleType: 0,
          isCopy: false,
          isShowStop: false,
          isThinking: false,
        });
        if (replyMessage) {
          Object.assign(replyMessage, wikiAnswer);
        } else {
          this.messageList_copy.push(wikiAnswer);
        }
        if (this.channelId == null || this.channelId == 2) {
          await this.getChatMoreQuestions(chatInfo, jsonData.data.question_id);
        }
        if (this.channelId != null && this.channelId == 3) {
          const obj = Object.assign({
            channelId: this.channelId,
            sessionId: this.sessionId,
            title: this.$t("chat.title.satisfied"),
            sendTime: this.$options.filters.formatDate(new Date()),
            roleType: "bomForm",
          });
          this.messageList.push(obj);
          this.toBottom(100);
          return;
        }
      } else if (jsonData.retcode === 108) {
        if (replyMessage) {
          const replyIndex = this.messageList_copy.indexOf(replyMessage);
          if (replyIndex > -1) {
            this.messageList_copy.splice(replyIndex, 1);
          }
        }
        const obj = Object.assign({
          channelId: this.channelId,
          sessionId: this.sessionId,
          title: this.$t("chat.title.freeUsedUp"),
          sendTime: this.$options.filters.formatDate(new Date()),
          roleType: "vipForm",
        });
        this.messageList.push(obj);
        this.toBottom(100);
      } else {
        if (replyMessage) {
          replyMessage.isThinking = false;
          replyMessage.isShowStop = false;
          replyMessage.sendMessage = "请求异常，请稍后重试！";
        }
        this.$message.error("请求异常，请稍后重试！");
      }
      this.$emit("rollbackLoading", false);
    },
    // 获取相似问题
    async getChatMoreQuestions(chatInfo, questionId) {
      // 获取该问题的相似问题
      const params = Object.assign({
        question_id: questionId,
      });
      const moreQuestion = await getMoreQuestions(params);
      if (moreQuestion && moreQuestion.retcode === 200) {
        const questions = moreQuestion.data.question;
        if (questions && questions.length > 0) {
          this.messageList.push({
            channelId: this.channelId,
            sessionId: this.sessionId,
            title: this.$t("chat.title.moreRelated"),
            questions: questions,
            sendTime: new Date(),
            roleType: "more",
          });
        }
      }
      this.toBottom(200);
    },
    // 回到底部
    toBottom(time) {
      setTimeout(() => {
        const MobileRightCont = document.getElementById("userMobileMessage");
        if (MobileRightCont != null) {
          const scrollHeight2 = MobileRightCont.scrollHeight;
          MobileRightCont.scrollTop = scrollHeight2;
        }
      }, time);
      clearTimeout();
    },
  },
};
</script>
<style>
.markdown-body {
  background-color: transparent !important;
  color: #1f2328 !important;
  min-height: unset !important;
  font-size: unset !important;
}

.markdown-body ol li::marker {
  font-weight: bold;
  font-size: 1em;
}

.thinking-text {
  animation: thinking-blink 1.2s ease-in-out infinite;
}

@keyframes thinking-blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.35;
  }
}

.el-menu-vertical {
  z-index: 99999;
  border: 1px solid #e3e3e3;
  background-color: #fff;
  width: 300px;
  padding: 0;
  margin: 0;
}
.menuItem {
  color: #999;
  line-height: 30px;
  height: 30px;
  padding: 0;
  margin: 0;
}
.menuItem:hover {
  background-color: #f3f3f3;
  color: #999;
}
.menuItem .is-active {
  background-color: #f3f3f3;
  color: #999;
}
.el-menu-item.is-active {
  color: #999;
  background-color: #fff !important;
}
.el-menu-item.is-active:hover {
  background-color: #f3f3f3 !important;
  color: #999;
}

.pdf-abstract-info table {
  border-collapse: collapse;
  width: 100%;
}

.pdf-abstract-info th,
td {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

.pdf-abstract-info th {
  text-align: center;
  background-color: #dae1f1;
}

.pdf-abstract-info caption {
  margin: 10px 0;
}

.MobileRightCont .customerServiceDiv .answers .text p {
  margin: 0;
  padding: 0;
}

.MobileRightCont .myselfDiv .news .text p {
  margin: 0;
  padding: 0;
}

.MobileRightCont .customerServiceDiv .answers .text img {
  max-width: 100%;
  height: auto;
  cursor: zoom-in;
}

.MobileRightCont .customerServiceDiv .answers .text table {
  border-collapse: collapse;
  min-width: 800px;
}

.MobileRightCont .customerServiceDiv .answers .text th,
td {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

.MobileRightCont .customerServiceDiv .answers .text th {
  text-align: center;
  background-color: #dae1f1;
}

.MobileRightCont .customerServiceDiv .answers .text caption {
  margin: 10px 0;
}

.MobileRightCont .myselfDiv .news .text img {
  max-width: 100%;
  height: auto;
  cursor: zoom-in;
}

.MobileRightCont .myselfDiv .news .user-image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
  margin-bottom: 8px;
}

.MobileRightCont .myselfDiv .news .user-image-list img {
  max-width: 120px;
  max-height: 120px;
  border-radius: 8px;
  object-fit: cover;
  cursor: zoom-in;
}

.MobileRightCont .myselfDiv .news .user-file-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
  margin-bottom: 8px;
}

.MobileRightCont .myselfDiv .news .user-file-list .file-item img {
  max-width: 120px;
  max-height: 120px;
  border-radius: 8px;
  object-fit: cover;
  cursor: zoom-in;
}

.MobileRightCont .myselfDiv .news .user-file-list .file-item .file-link {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  background: #f0f2f5;
  border-radius: 6px;
  color: #409eff;
  text-decoration: none;
  font-size: 13px;
}

.MobileRightCont .myselfDiv .news .user-file-list .file-item .file-link:hover {
  background: #e6e8eb;
}

.MobileRightCont .myselfDiv .news .text table {
  border-collapse: collapse;
  width: 100%;
}

.MobileRightCont .myselfDiv .news .text th,
td {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

.MobileRightCont .myselfDiv .news .text th {
  text-align: center;
  background-color: #dae1f1;
}

.MobileRightCont .myselfDiv .news .text caption {
  margin: 10px 0;
}
</style>
<style scoped lang="scss">
@import "~@/styles/mixin.scss";

.overflow-hidden-2 {
  line-height: 21px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

.overflow-hidden {
  line-height: 20px;
  height: 20px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

.MobileRightCont {
  .more-hot-question {
    margin-top: 10px;
    cursor: pointer;
    padding: 0 10px;
    border: 1px solid #849bdf;
    background-color: #ffffff;
    border-radius: 8px;
    color: #333333;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  ::v-deep .el-menu-item {
    margin-top: 0px !important;
    height: 30px !important;
  }
  -webkit-box-flex: 1;
  overflow-y: scroll;
  .chat-init {
    width: 100%;
    display: flex;
    padding: 20px;
    flex-direction: column;
    align-items: center;
    .item {
      margin-bottom: 20px;
    }

    @include respond-to("pad") {
      .text {
        width: 80%;
      }
      .logo {
        margin-top: 50px;
      }
      .item {
        margin-bottom: 40px;
      }
    }

    @include respond-to("notebook") {
      .text {
        width: 80%;
      }
      .logo {
        margin-top: 50px;
      }
      .item {
        margin-bottom: 40px;
      }
    }
  }

  .init-question {
    @include respond-to("pad") {
      width: 80%;
    }

    @include respond-to("notebook") {
      width: 80%;
    }
    .refresh {
      padding: 5px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .refresh-button {
        color: rgb(151 151 151);
        &:hover {
          color: #ff6a00;
        }
      }
    }
    .question {
      display: grid;
      column-gap: 12px;
      row-gap: 12px;
      box-sizing: border-box;
      grid-template-columns: repeat(1, 1fr);

      .question-div {
        height: 80px;
        padding: 8px 10px;
        background-color: #f1f5fd;
      }
      @include respond-to("desktop") {
        grid-template-columns: repeat(2, 1fr);
      }
      @include respond-to("pad") {
        .question-div {
          height: 110px;
          padding: 14px 16px;
          background-color: #f1f5fd;
        }
        grid-template-columns: repeat(2, 1fr);
      }

      @include respond-to("notebook") {
        .question-div {
          height: 110px;
          padding: 14px 16px;
          background-color: #f1f5fd;
        }
        grid-template-columns: repeat(2, 1fr);
      }

      .question-content {
        display: flex;
        margin-top: 10px;
        justify-content: space-between;
        img {
          height: 60px;
          @include respond-to("phone") {
            height: 40px;
          }
          width: auto;
          margin-left: 14px;
          border-radius: 8px;
        }
      }
      ::v-deep .el-card {
        border-radius: 8px;
      }
      .div-disabled {
        cursor: not-allowed;
        background-color: #f9f9f9 !important;
      }
    }
  }

  &::-webkit-scrollbar {
    width: 1px;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  li {
    width: 100%;
    height: 50px;
    /*display: -webkit-box;*/
    /*-webkit-box-orient: horizontal;*/
    margin-top: 20px;
    position: relative;
  }

  .nesHead {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    margin-left: 15px;
    float: right;
  }

  .customerServiceDiv {
    float: left;
    margin: 1.25rem 0rem;
    position: relative;
    word-wrap: break-word;
    word-break: break-all;
    width: 100%;
    .more-image {
      cursor: pointer;
      width: 30px;
      height: 30px;
      margin-right: 10px;
      &:last-child {
        margin-right: 0;
      }
    }

    .advice {
      position: absolute;
      left: 14px;
      bottom: -30px;
      display: flex;
      align-items: center;
      .export-excel {
        width: 16px;
        height: 16px;
        cursor: pointer;
        margin-left: 3px;
      }
      span {
        font-size: 16px;
        cursor: pointer;
        margin: 0 3px;
      }
    }

    .answers {
      letter-spacing: 1px;
      line-height: 22px;
      width: auto;
      background: #f7f9ff;
      padding: 10px 10px;
      margin: 4px;
      font-size: 14px;
      border-radius: 10px;
      position: relative;
      float: left;
      color: black;
      .bom-form {
        ::v-deep .el-form-item__label {
          font-weight: 400 !important;
          color: black !important;
        }
        ::v-deep .el-form-item {
          margin-bottom: 10px;
        }
      }
      .jiao {
        position: absolute;
        left: -8px;
        top: 10px;
      }
      .text {
        /*overflow: hidden;*/
      }
      .cite-path {
        color: #ff6a00;
        &:hover {
          color: #ff8833;
        }
      }
    }
  }

  .myselfDiv {
    float: right;
    margin: 0.35rem 0;
    display: flex;
    position: relative;
    word-wrap: break-word;
    word-break: break-all;
    width: 100%;
    justify-content: flex-end;

    .news {
      width: auto;
      height: auto;
      background: #ff7043;
      padding: 10px 20px;
      margin: 4px;
      line-height: 20px;
      font-size: 14px;
      border-radius: 10px;
      position: relative;
      float: right;
      color: #ffffff;
      max-width: 350px;

      .jiao {
        position: absolute;
        right: -8px;
        top: 10px;
      }
    }
  }

  .noticeDiv {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    .moreSession {
      width: auto;
      background: #d1d1d1;
      border-radius: 10px;
      color: #fff;
      line-height: 16px;
      text-align: center;
      margin: 0 auto;
      margin-top: 2px;
      padding: 3px 8px;
      font-size: 12px;
    }
  }

  .initLoadingDiv {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 80%;

    .animation_div {
      position: relative;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      box-sizing: border-box;
      color: aquamarine;
      font-size: 12px;
      line-height: 12px;
      text-align: center;

      &::before {
        position: absolute;
        left: 0;
        top: 0;
        display: block;
        content: "";
        width: 12px;
        height: 12px;
        border-width: 1px;
        border-style: solid;
        border-color: #00ffff transparent transparent transparent;
        box-sizing: content-box;
        animation: trotate 1.5s linear infinite;
        border-radius: 50%;
        z-index: 2;
      }

      &::after {
        position: absolute;
        left: -3px;
        top: -3px;
        display: block;
        content: "";
        width: 15px;
        height: 15px;
        border-width: 1px;
        border-style: solid;
        border-color: #ff0000 transparent transparent transparent;
        box-sizing: content-box;
        animation: trotate 1s linear infinite;
        border-radius: 50%;
        z-index: 1;
      }
    }
  }
}
</style>
